// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// TODO: el mensaje de bienvenida debe ser parametrico respecto al servicio en linea (Declaracion Nominada, Servicio x, servicio y, etc.)

export const alissMensajes = {
  systemType: 'system',
  notificacion: 'Nuevo mensaje',
  separadorHistorico: '*********************************************************',
  posicionEnCola: 'Te encuentras en el lugar NN para ser atendido',
  confirmacionCierre: '¿Desea cerrar la ventana y terminar la conversación?',
  warningOtroServicio : 'Usted mantiene una conversación activa en el chat del servicio "DESC_SERV". La misma será finalizada si decide iniciar esta nueva comunicación.',
  conversacionFinalizada : 'La conversación ha finalizado, gracias por comunicarte con nosotros.'

};
